import { render, staticRenderFns } from "./jng_wx_user.vue?vue&type=template&id=3132f732&scoped=true&"
import script from "./jng_wx_user.vue?vue&type=script&lang=js&"
export * from "./jng_wx_user.vue?vue&type=script&lang=js&"
import style0 from "./jng_wx_user.vue?vue&type=style&index=0&id=3132f732&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3132f732",
  null
  
)

export default component.exports